import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = { type: String, message: String }

  connect() {
    if (this.messageValue) {
      this.showAlert()
    }
  }

  showAlert() {
    Swal.fire({
      title: this.typeValue === "alert" ? "Errore" : "Successo",
      text: this.messageValue,
      icon: this.typeValue === "alert" ? "error" : "success",
      confirmButtonColor: "#465fff",
      confirmButtonText: "OK"
    })
  }
}
